import {
  BigLabel,
  BigPercentage,
  InfoWrapper,
  IconWrapper,
  SmallLabel,
  SmallPercentage,
  TextsWrapper,
  Wrapper
} from './ShowInformation.styles';

import { EIconType, Icon } from '@/components/Icon';

type CommonProps = {
  bigLabel: string;
  smallLabel?: string;
  bigPercentage: string;
  smallPercentage?: React.JSX.Element;
};

export type Props =
  | (CommonProps & { icon: EIconType; image?: never })
  | (CommonProps & { image: React.JSX.Element; icon?: never });

export const ShowInformation: React.FC<Props> = ({
  bigLabel,
  smallLabel,
  bigPercentage,
  smallPercentage,
  icon,
  image
}) => {
  const visual = icon ? <Icon i={icon} color="purple7" size={16} /> : image;

  return (
    <Wrapper>
      <IconWrapper>{visual}</IconWrapper>
      <TextsWrapper>
        <InfoWrapper>
          <BigLabel>{bigLabel}</BigLabel>
          <BigPercentage>{bigPercentage}</BigPercentage>
        </InfoWrapper>
        {smallLabel && smallPercentage && (
          <InfoWrapper>
            <SmallLabel>{smallLabel}</SmallLabel>
            <SmallPercentage>{smallPercentage}</SmallPercentage>
          </InfoWrapper>
        )}
      </TextsWrapper>
    </Wrapper>
  );
};
